import { Stack } from '@mui/material';
import LangEnum from '../../../../../../../../../lang/LangEnum';
import { OrderConditionShippingVisibility } from '../../../orderObjectConditionsTab.types';
import OrderConditionReadOnlyField from '../../OrderConditionReadOnlyField';

interface OrderConditionReadOnlyDeliverySectionProps {
  deliveryAddressValue?: string;
  shippingCostValue?: string;
  visibility: OrderConditionShippingVisibility;
}

const OrderConditionReadOnlyDeliverySection = ({
  deliveryAddressValue,
  shippingCostValue,
  visibility,
}: OrderConditionReadOnlyDeliverySectionProps) => {
  const { isShippingCostVisible } = visibility;

  return (
    <Stack sx={{ gap: 2 }}>
      <OrderConditionReadOnlyField
        label={LangEnum.ORDER_CONDITIONS_DELIVERY_ADDRESS_LABEL}
        value={deliveryAddressValue}
      />

      {isShippingCostVisible && (
        <OrderConditionReadOnlyField
          label={LangEnum.GLOBAL_SHIPPING_COST}
          value={shippingCostValue}
        />
      )}
    </Stack>
  );
};

export default OrderConditionReadOnlyDeliverySection;
